import React from "react";
import { useAppSelector } from '../../app/hooks';
import strings, { selectLanguage } from '../../components/localize/localizeSlice';

interface PriceEstimationDisplayProps {
  PLD_ID: string;
  PLD_ID_HAUPT: string;
  PLD_PREIS_NETTO: string;
  PLD_PREIS_BRUTTO: string;
  PLD_PREIS_ZUSCHLAG: string;
  PLD_MWST_SATZ: string;
  PLD_MENGE_RUNDEN: string;
  PLD_MENGE_MINDESTENS: string;
  PLD_EINHEIT: string;
  PLD_UNTERDRUECKEN: string;
  PLD_PRL_ID: string;
  PLD_PNL_ID: string;
  PLD_PNA_ZEITRAUM_ID: string;
  PLD_PORTAL_KEY: string;
  ART_CODE: string;
  ART_NAME: string;
  ART_MENGENBESTIMMUNG: string;
  ART_ZEITBEREICHBESTIMMUNG: string;
  ART_BESCHREIBUNG: string;
  ART_BESCHREIBUNG_NICHT_NUTZEN: string;
  ART_TAE_CODES: string;
  ART_ERLOESKONTO: string;
  ART_ERLOESKONTO_EU: string;
  ART_ERLOESKONTO_NOT_EU: string;
  PLD_GESPERRT: string;
  PLD_ALLOW_CHANGE: string;
  PLD_ON_MOBILE: string;
  PLD_POS: string;
  PLD_EXT_CODE: string;
  PMW_MWST_SATZ: string;
  TotalNetto: string;
  TotalBrutto: string;
  Count: string;
}
type PriceEstimationDisplayPropsArray = {
  positions: PriceEstimationDisplayProps[];
};

const PriceEstimationDisplay: React.FC<PriceEstimationDisplayPropsArray> = (pricelist) => {
  useAppSelector(selectLanguage);

    return (
    <div className="bg-white dark:bg-gray-800  p-2">
      {/* Total Price */}
      <div className="text-left mb-6">
        <h2 className="text-4xl font-extrabold text-cuno-500 dark:text-blue-400">
            {pricelist.positions
              .reduce((sum, item) => sum + (parseFloat(item.TotalNetto || "0") *
                  (1 + parseFloat(item.PMW_MWST_SATZ || "0") / 100)), 0)
              .toLocaleString("de-DE", {
              style: "currency",
              currency: "EUR",
              })}
            <div className="text-base font-normal text-gray-600 dark:text-gray-300 mt-1">
              {
              strings.formatString(strings.form.priceCalculation.additionalMwst, {amount: pricelist.positions
                .reduce(
                (sum, item) =>
                  sum +
                  (parseFloat(item.TotalNetto || "0") *
                  (1 + parseFloat(item.PMW_MWST_SATZ || "0") / 100)) -
                  parseFloat(item.TotalNetto || "0"),
                0
                )
                .toLocaleString("de-DE", {
                style: "currency",
                currency: "EUR",
                })})
              }
            </div>
        </h2>
        <p className="text-gray-500 dark:text-gray-400 text-sm">
          {strings.form.priceCalculation.total}
        </p>
      </div>
      <div className="flex justify-between items-start  py-3 text-gray-700 dark:text-gray-300 font-bold">
              <span className="text-sm w-20">{strings.form.priceCalculation.item}</span>
              <span className="text-sm">{strings.form.priceCalculation.amount}</span>
              <span className="text-sm w-25 text-gray-900 dark:text-white">{strings.form.priceCalculation.itemTotal}</span>
            </div>
      {/* Breakdown */}
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {pricelist.positions.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center py-3 text-gray-700 dark:text-gray-300"
          >
            <span className="text-sm font-sm w-20">{item.ART_NAME}</span>
            <span className="text-sm font-sm ">{item.Count}</span>
            <span className="text-sm w-25   text-gray-900 dark:text-white">
              {item.TotalNetto !== undefined
                ? parseFloat(item.TotalNetto).toLocaleString("de-DE", {
                    style: "currency",
                    currency: "EUR",
                  })
                : ""}
            </span>
          </div>
        ))}
      </div>
      
      {/* Disclaimer */}
      <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed whitespace-pre-line">
          {strings.form.priceCalculation.disclaimer}
        </p>
      </div>
    </div>
  );
};

export default PriceEstimationDisplay;
export type { PriceEstimationDisplayProps };